<template>
  <div>
    <!--筛选栏-->
    <Row type="flex" :space-x="10" class="margin-right-left padding-top" align="middle">
      <Cell>
        <DatePicker v-model="filter.start" format="yyyy-MM-dd" placeholder="开始日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <DatePicker v-model="filter.end" format="yyyy-MM-dd" placeholder="结束日期" style="width:140px"></DatePicker>
      </Cell>
      <Cell>
        <Button color="primary" @click="loadList">查询</Button>
      </Cell>
      <Cell>
        <Button color="success" @click="openAdd">新增盘点单</Button>
      </Cell>
      <Cell>
        <Button @click="doPreview" :disabled="!selectedIds.length">凭证预览</Button>
      </Cell>
      <Cell>
        <Button color="primary" @click="doGenerate" :disabled="!selectedIds.length">生成凭证</Button>
      </Cell>
    </Row>

    <!--列表-->
    <div class="h-panel-body padding-top">
      <Table :datas="list" :border="true" :loading="loading" multiSelect @selection-change="onSelect">
        <TableItem type="check" width="50" :prop="'id'"></TableItem>
        <TableItem title="单据编号" prop="code" :width="170"></TableItem>
        <TableItem title="盘点日期" prop="billDate" :width="120"></TableItem>
        <TableItem title="盘点人/仓库" prop="supplierName" :width="130"></TableItem>
        <TableItem title="盘盈(亏)金额" align="right">
          <template slot-scope="{data}">
            <b :class="Number(data.amount) < 0 ? 'loss' : 'gain'">{{ money(data.amount) }}</b>
          </template>
        </TableItem>
        <TableItem title="状态" :width="110" align="center">
          <template slot-scope="{data}">
            <Tag :color="data.status === 2 ? 'success' : 'warning'">
              {{ data.status === 2 ? '已生成凭证' : '未生成凭证' }}
            </Tag>
          </template>
        </TableItem>
        <TableItem title="备注" prop="remark"></TableItem>
        <TableItem title="操作" :width="110" align="center">
          <template slot-scope="{data}">
            <span class="link" @click="openEdit(data)">编辑</span>
            <span class="link danger" @click="doDelete(data)">删除</span>
          </template>
        </TableItem>
      </Table>
      <Pagination :page="filter.page" size="small" :total="total" @change="onPage" class="margin-top text-right"></Pagination>
    </div>

    <!--编辑弹窗-->
    <Modal v-model="modal" :title="form.id ? '编辑盘点单' : '新增盘点单'" width="900">
      <Form ref="form" mode="twocolumn" :labelWidth="110" :model="form" :rules="validationRules">
        <FormItem label="盘点日期" prop="billDate">
          <DatePicker v-model="form.billDate" format="yyyy-MM-dd"></DatePicker>
        </FormItem>
        <FormItem label="盘点人/仓库">
          <input type="text" v-model="form.supplierName">
        </FormItem>
      </Form>

      <Table :datas="form.details" :border="true" class="margin-top">
        <TableItem title="物料" :width="260">
          <template slot-scope="{data}">
            <Select v-model="data.materielId" filterable transfer-class-name="h-transfer">
              <Option v-for="m in materials" :value="m.id" :key="m.id">{{ m.code }} {{ m.name }}</Option>
            </Select>
          </template>
        </TableItem>
        <TableItem title="账面数量" :width="120">
          <template slot-scope="{data}">
            <input type="number" v-model.number="data.systemQty">
          </template>
        </TableItem>
        <TableItem title="实盘数量" :width="120">
          <template slot-scope="{data}">
            <input type="number" v-model.number="data.actualQty">
          </template>
        </TableItem>
        <TableItem title="单价" :width="120">
          <template slot-scope="{data}">
            <input type="number" v-model.number="data.price">
          </template>
        </TableItem>
        <TableItem title="差异数量" :width="100" align="right">
          <template slot-scope="{data}">{{ diffQty(data) }}</template>
        </TableItem>
        <TableItem title="差异金额" :width="110" align="right">
          <template slot-scope="{data}">
            <span :class="diffQty(data) < 0 ? 'loss' : 'gain'">{{ money(diffAmount(data)) }}</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="70" align="center">
          <span slot-scope="{data,$index}" class="link danger" @click="form.details.splice($index,1)">移除</span>
        </TableItem>
      </Table>
      <Button size="small" class="margin-top" @click="addDetail">+ 添加明细</Button>

      <Form ref="remarkForm" :labelWidth="110" :model="form" class="margin-top">
        <FormItem label="备注">
          <textarea v-model="form.remark" rows="2" style="width:100%"></textarea>
        </FormItem>
      </Form>

      <div slot="bottom">
        <Button @click="modal = false">取消</Button>
        <Button color="primary" @click="doSave" :loading="saving">保存</Button>
      </div>
    </Modal>

    <!--凭证预览-->
    <Modal v-model="previewModal" title="凭证预览" width="760">
      <div v-for="(v, i) in previewList" :key="i">
        <div class="voucher-title">盘点单：{{ v.orderCode }}</div>
        <Table :datas="v.lines" :border="true">
          <TableItem title="摘要" prop="summary"></TableItem>
          <TableItem title="科目" prop="subjectName"></TableItem>
          <TableItem title="借方" prop="jie" align="right"></TableItem>
          <TableItem title="贷方" prop="dai" align="right"></TableItem>
        </Table>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: 'InventoryCheck',
  data() {
    return {
      filter: {start: '', end: '', page: 1},
      list: [],
      total: 0,
      loading: false,
      selectedIds: [],
      materials: [],
      modal: false,
      saving: false,
      form: this.blankForm(),
      validationRules: {
        required: ['billDate']
      },
      previewModal: false,
      previewList: []
    };
  },
  methods: {
    blankForm() {
      return {
        id: null, billDate: new Date(), supplierName: '', remark: '', details: []
      };
    },
    blankDetail() {
      return {materielId: null, systemQty: 0, actualQty: 0, price: 0};
    },
    money(val) {
      let n = Number(val);
      return isNaN(n) ? '0.00' : n.toFixed(2);
    },
    diffQty(data) {
      return Number(data.actualQty || 0) - Number(data.systemQty || 0);
    },
    diffAmount(data) {
      return this.diffQty(data) * Number(data.price || 0);
    },
    addDetail() {
      this.form.details.push(this.blankDetail());
    },
    loadMaterials() {
      this.$api.setting.inventoryMaterial.list({page: 1, size: 500}).then(({data}) => {
        this.materials = data.records || data.results || data || [];
      }).catch(() => {});
    },
    loadList() {
      this.loading = true;
      let params = Object.assign({page: this.filter.page, pageSize: 20}, this.filter);
      this.$api.pro.inventoryCheck.list(params).then(({data}) => {
        this.list = data.results || [];
        this.total = data.total || 0;
      }).finally(() => this.loading = false);
    },
    onPage(page) {
      this.filter.page = page;
      this.loadList();
    },
    onSelect(selection) {
      this.selectedIds = selection.map(r => r.id);
    },
    openAdd() {
      this.form = this.blankForm();
      this.addDetail();
      this.modal = true;
    },
    openEdit(row) {
      this.$api.pro.inventoryCheck.load(row.id).then(({data}) => {
        if (!data.details || !data.details.length) {
          data.details = [this.blankDetail()];
        }
        this.form = data;
        this.modal = true;
      });
    },
    doSave() {
      let validResult = this.$refs.form.valid();
      if (!validResult.result) {
        return;
      }
      let validDetails = (this.form.details || []).filter(d => d.materielId);
      if (!validDetails.length) {
        this.$Message.warning('请至少填写一条盘点明细');
        return;
      }
      this.form.details = validDetails;
      this.saving = true;
      this.$api.pro.inventoryCheck.save(this.form).then(() => {
        this.$Message.success('盘点单保存成功');
        this.modal = false;
        this.loadList();
      }).finally(() => this.saving = false);
    },
    doDelete(data) {
      this.$Confirm(`确认删除盘点单 ${data.code}？`).then(() => {
        this.$api.pro.inventoryCheck.del(data.id).then(() => {
          this.$Message.success('删除成功');
          this.loadList();
        });
      });
    },
    doPreview() {
      this.$api.pro.inventoryCheck.preview(this.selectedIds).then(({data}) => {
        this.previewList = data || [];
        this.previewModal = true;
      });
    },
    doGenerate() {
      this.$Confirm('确认为所选盘点单生成凭证？').then(() => {
        this.$api.pro.inventoryCheck.generate(this.selectedIds).then(({data}) => {
          this.$Message.success(data || '凭证生成成功');
          this.loadList();
        });
      });
    }
  },
  mounted() {
    this.loadMaterials();
    this.loadList();
  }
}
</script>

<style lang="less" scoped>
.margin-top {
  margin-top: 10px;
}
.gain {
  color: #ed4014;
}
.loss {
  color: #19be6b;
}
.link {
  color: #2d8cf0;
  cursor: pointer;
  margin: 0 5px;
  &.danger {
    color: #ed4014;
  }
}
.voucher-title {
  margin: 10px 0;
  font-weight: bold;
}
</style>
